import React, { useState, useEffect } from "react";
import "./topSelling.css";
import CardFilter from "./CardFilter";
import TopSellingItem from "./TopSellingItem";

export default function TopSelling() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("Hoy");
  const handleFilterChange = (filter) => {
    setFilter(filter);
  };

  const fetchData = () => {
    setItems([
      {
        _id: 1,
        preview: "../assets/items/product-1.jpg",
        name: "Ut inventore ipsa voluptas nulla",
        price: 64,
        sold: 124,
      },
      {
        _id: 2,
        preview: "../assets/items/product-2.jpg",
        name: "Exercitationem similique doloremque",
        price: 46,
        sold: 98,
      },
      {
        _id: 3,
        preview: "../assets/items/product-3.jpg",
        name: "Doloribus nisi exercitationem",
        price: 59,
        sold: 74,
      },
      {
        _id: 4,
        preview: "../assets/items/product-4.jpg",
        name: "Officiis quaerat sint rerum error",
        price: 32,
        sold: 63,
      },
      {
        _id: 5,
        preview: "../assets/items/product-5.jpg",
        name: "Sit unde debitis delectus repellendus",
        price: 79,
        sold: 41,
      },
    ]);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="card top-selling overflow-auto">
      <CardFilter filterChange={handleFilterChange} />
      <div className="card-body pb-0">
        <h5 className="card-title">
          Top Ventas <span>|{filter}</span>
        </h5>
        <table className="table table-borderless datable">
          <thead className="table-light" style={{ textAlign: "center" }}>
            <tr>
              <th scope="col">Preview</th>
              <th scope="col">Producto</th>
              <th scope="col">Precio</th>
              <th scope="col">Vendido</th>
              <th scope="col">Ganancia</th>
            </tr>
          </thead>
          <tbody>
            {items &&
              items.length > 0 &&
              items.map((item) => (
                <TopSellingItem key={item._id} item={item} />
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
